import { MhpDetails } from 'modules/types/common';
import { getAuthLiteHeaders } from 'services/AuthServices.web';
import { RootDispatch, RootState } from 'store/types';

// Auth lite
export const GET_AUTH_LITE_DOCUMENT_BY_ID = 'CLINIC_NOTES.GET_AUTH_LITE_DOCUMENT_BY_ID';
export const GET_AUTH_LITE_DOCUMENT_BY_ID_SUCCESS =
  'CLINIC_NOTES.GET_AUTH_LITE_DOCUMENT_BY_ID_SUCCESS';
export const GET_AUTH_LITE_DOCUMENT_BY_ID_FAIL = 'CLINIC_NOTES.GET_AUTH_LITE_DOCUMENT_BY_ID_FAIL';

export const getAuthLiteDocumentById = (mhpDetails: MhpDetails) => async (
  dispatch: RootDispatch,
  getState: () => RootState
) => {
  dispatch({
    type: GET_AUTH_LITE_DOCUMENT_BY_ID,
    payload: {
      client: 'dispatcher',
      request: {
        method: 'get',
        headers: {
          ...getAuthLiteHeaders(getState()),
          ...(mhpDetails?.headers || {}),
          accept: 'application/pdf'
        },
        url: mhpDetails?.url
      }
    }
  });
};

export * from './actions.common';
